/**
 * واژه‌ای که با نگه داشتنِ ماوس خودش را توضیح می‌دهد.
 *
 * ═══ چرا `title`ِ خودِ مرورگر و نه یک تولتیپِ CSSی ═══
 *
 * این اجبار است نه سلیقه. تقریباً همه‌ی جاهایی که این واژه‌ها می‌نشینند
 * داخلِ `.scrollx` هستند که `overflow-x: auto` دارد، و هر چیزی که با
 * `position: absolute` از مرزِ آن بیرون بزند بریده می‌شود — یعنی توضیحِ
 * ستونِ آخرِ یک جدولِ پهن هیچ‌وقت کامل دیده نمی‌شد. `title` بیرونِ جریانِ
 * صفحه رندر می‌شود و این مشکل را اصلاً ندارد.
 *
 * ضمناً همان الگویی است که سربرگِ «منابع» از قبل به کار می‌برد
 * (`STAGE_HELP`، `TODO_HELP`، `NEED`)، پس رفتارِ ادمین یکدست می‌ماند.
 *
 * ═══ چرا زیرخطِ نقطه‌چین ═══
 *
 * ⚠️ تزئین نیست، تنها **نشانه‌ی وجودِ توضیح** است. `title` بدونِ هیچ اثرِ
 * دیداری یعنی توضیحی که فقط به کسی می‌رسد که اتفاقی ماوسش را همان‌جا نگه
 * دارد — و آن کس همان کسی است که از قبل معنی را می‌داند.
 *
 * ⚠️ `help` که نباشد هیچ زیرخطی هم نمی‌آید: نشانه‌ای که پشتش توضیحی نباشد
 * از نبودنِ نشانه بدتر است.
 *
 * روی چیزی که از قبل دکمه یا لینک است (`.linkbtn`، `.chip`ِ کلیک‌شدنی)
 * به‌جای این کامپوننت، `title` را مستقیم به خودش بده: زیرخطِ دوم فقط شلوغی
 * است و آن عنصر خودش دعوت به ماوس بردن هست.
 */
import React from 'react';

export function Hint({ text, help }: { text: string; help?: string }) {
  if (!help) return <>{text}</>;
  return <span className="hint" title={help}>{text}</span>;
}
